"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var localization_1 = require("@scuf/localization");
var PageDetails = /** @class */ (function (_super) {
    __extends(PageDetails, _super);
    function PageDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageDetails.prototype.render = function () {
        var _a = this.props, totalItems = _a.totalItems, firstItemInCurrentPage = _a.firstItemInCurrentPage, lastItemInCurrentPage = _a.lastItemInCurrentPage, t = _a.t;
        return React.createElement("span", { className: "page-info" },
            React.createElement("span", { className: "bold" },
                firstItemInCurrentPage,
                " - ",
                lastItemInCurrentPage),
            " ",
            t('of'),
            " ",
            React.createElement("span", { className: "bold" }, totalItems),
            " ",
            t('Items'));
    };
    return PageDetails;
}(React.Component));
exports.PageDetails = PageDetails;
exports.default = localization_1.InjectLocalization(PageDetails);
